const certificatesSlider = document.querySelectorAll('[data-slider="certificates-module__slider"]');

const certificatesSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 54,
  speed: 800,
  breakpoints: {
    1200: {
      spaceBetween: 0,
    },
  },
};

certificatesSlider.forEach((el) => {
  new Swiper(el, certificatesSliderOptions);
});
